<template>
    <div class="locator__map">
        <GmapMap :center="mapCenter" :zoom="mapZoom" style="width: 100%; height: 100%" ref="map">
            <GmapMarker
                    :key="i"
                    v-for="(m, i) in markers"
                    :position="m.position"
                    :clickable="true"
                    :draggable="false"
                    @click="highlight(m)"
            />
        </GmapMap>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'LocatorMap',
        watch: {
            markers(markers) {
                if (markers.length) {
                    const bounds = new google.maps.LatLngBounds()
                    for (let m of markers) {
                        bounds.extend(m.position)
                    }
                    this.$refs.map.fitBounds(bounds)
                }
            }
        },
        props: {
            onPinClick: {
                type: Function | null,
                default: null,
            }
        },
        computed: {
            ...mapGetters('locator', ['markers', 'mapCenter', 'mapZoom']),
        },
        methods: {
            highlight(contact) {
                const contactId = 'contact-' + contact.id;
                const contactElement = document.getElementById(contactId);
                const placeItems = document.querySelectorAll('.places__item');
                for (let i = 0; i < placeItems.length; ++i) {
                    placeItems[i].removeAttribute('style');
                }
                if (null !== contactElement) {
                    contactElement.style.backgroundColor = "#f1f1f1";
                    contactElement.scrollIntoView();
                }
                if (this.onPinClick) {
                    this.onPinClick(contact.token);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/Map.vue